import { FC } from 'react';
import { useLoginAdapter } from './login-adapter';

// -----------------------------------------------------------------------------
const MiniProfileView: FC<any> = (props) => {
  const { handleClose } = props;
  const { currentUser, logout } = useLoginAdapter();

  if (!currentUser?.profile) {
    return <></>;
  }

  // ---------------------------------------------------------------------------
  return (
    <div className="profile-username-edit-window">
      <div className="profile-username-edit-modal">
        <img src={currentUser?.profile.avatar ?? ''} alt="username" />
        <h1>Welcome {currentUser?.profile.nickname ?? 'Guest'}</h1>
        <p>
          You can edit your display name and profile image, or continue to
          Overwolf.
        </p>
        <div className="actions-box">
          <button onClick={logout} className="btn-secondary">
            Logout
          </button>
          <button onClick={() => handleClose()} className="btn-primary">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiniProfileView;
